<template>
  <b-container
    :class="backgroundClass"
    fluid
  >
    <b-container class="sectionArticles pt-5 pb-5">
      <b-row>
        <b-col
          cols="12"
          lg="7"
        >
          <h1
            :class="textClass"
            class="pb-4 sectionArticles__content"
          >
            {{ headline }}
          </h1>
        </b-col>
      </b-row>
      <b-row v-if="articles">
        <template v-for="article in articles">
          <text-column
            :key="article.index"
            :content="article.body"
            :column-amount="Number(article.columnAmount)"
            :class="textClass"
          />
        </template>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import TextColumn from './TextColumn.vue'

export default {
  name      : 'SectionArticles',
  components: { TextColumn },
  props     : {
    headline: { type: String, default: '' },
    articles: { type: Array, default: null },
    variant : {
      type   : String,
      default: '',
    },
    columns: {
      type   : String,
      default: '',
    },
  },
  computed: {
    backgroundClass () {
      return `bg-${this.variant}`
    },
    textClass () {
      let className = ''
      switch (this.variant) {
        case 'primary':
          className = 'text-light'
          break
        case 'secondary':
          className = 'text-light'
          break
        case 'light':
          className = 'text-dark'
          break
        case 'dark':
          className = 'text-light'
          break
      }
      return className
    },
  },
}
</script>

<style lang="scss" scoped>
.sectionArticles {
    @include media-breakpoint-only(xs) {
        padding: 0;
    }
  &__content {
    font-size: $spacer * 1.4;
    @include media-breakpoint-up(lg) {
      font-size: $spacer * 1.7;
    }
  }
}
</style>
